import * as React from "react";

const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg8"
    ariaHidden="true"
    className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium styles_rehearsalsIcon__YK7+E css-4uxqju-MuiSvgIcon-root"
    data-testid="ScheduleIcon"
    version="1.1"
    viewBox="0 0 24 24"
    {...props}
  >
    <g id="g919" fill="none" stroke="currentColor">
      <circle
        id="circle2"
        cx="12"
        cy="12"
        r="9.756"
        strokeDasharray="none"
        strokeWidth="1"
      ></circle>
      <path
        id="path4"
        stroke="currentColor"
        strokeLinecap="square"
        strokeWidth="3.61"
        d="M12.097 8.439v9.56M7.951 8.44h8.146"
      ></path>
    </g>
  </svg>
);

export default SvgIcon;
